export default function valueTrend(valueChange: $TSFixMe) {
  if (valueChange.slice(0, 1) === '+') {
    return 'positive';
  }
  if (valueChange.slice(0, 1) === '-') {
    return 'negative';
  }
  return null;
}
